export function sortItemlist(listClass) {
    var listContainer = $(listClass);
    var classSpecial = 'special_collection_spacer';
    var specialCollection = listContainer.find("." + classSpecial);

    var x = 0;

    if (specialCollection.length > 0) {
        while (specialCollection.length > x) {
            checkSpecialCollection(listClass);
            x++;
        }
    }
}